// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__udxmt","form":"styles_form__29uF0"};